
// ----------------------------------------------------
// Timeline
// ----------------------------------------------------

export const TIME_START = {
  H: 12,
  M: 30,
};

export const TIMELINE = [
  {
    pos: 0.05,
    posLimits: {
      min: 0,
      max: 0.08,
    },
    section: 'INTRO',
  },
  {
    pos: 0.1,
    posLimits: {
      min: 0.08,
      max: 0.12,
    },
    time: 0,
    timeline: {
      top: [
        {
          ico: 'case',
          video: '31561',
          hilite: '0-0',
        },
      ],
      bottom: [
        {
          ico: 'helmet',
          video: '31560',
          hilite: '0-1',
        },
      ],
    },
    map: {
      top: [
        {
          hidden: true,
          hiliteId: '0-0',
          label: '',
          ico: 'case',
          color: '#8396cc',
          pos: {
            x: -589,
            y: 175,
          },
        },
      ],
      bottom: [
        {
          hiliteId: '0-0',
          label: 'Situace v\u00a0dole',
          ico: 'case',
          color: '#677593',
          pos: {
            x: 642,
            y: 258,
          },
        },
        {
          hiliteId: '0-1',
          label: 'Příčina nehody',
          ico: 'helmet',
          color: '#b3403a',
          pos: {
            x: 565,
            y: 314,
          },
        },
      ],
    },
  },
  {
    pos: 0.3,
    posLimits: {
      min: 0.28,
      max: 0.32,
    },
    time: 180,
    timeline: {
      top: [
        {
          ico: 'case',
          video: '31563',
          hilite: '1-0',
        },
      ],
      bottom: [
        {
          ico: 'helmet',
          video: '31562',
          hilite: '1-1',
        },
      ],
    },
    map: {
      top: [
        {
          hidden: true,
          hiliteId: '1-0',
          label: '',
          ico: 'case',
          color: '#8396cc',
          pos: {
            x: -589,
            y: 175,
          },
        },
      ],
      bottom: [
        {
          hiliteId: '1-0',
          label: 'První hlášení',
          ico: 'case',
          color: '#677593',
          pos: {
            x: 537,
            y: 337,
          },
        },
        {
          hiliteId: '1-1',
          label: 'Horníci cítí zápach',
          ico: 'helmet',
          color: '#b3403a',
          pos: {
            x: 474,
            y: 372,
          },
        },
      ],
    },
  },
  {
    pos: 0.39,
    posLimits: {
      min: 0.37,
      max: 0.41,
    },
    time: 240,
    timeline: {
      top: [
        {
          ico: 'case',
          video: '31565',
          hilite: '2-0',
        },
      ],
      bottom: [
        {
          ico: 'helmet',
          video: '31564',
          hilite: '2-1',
        },
      ],
    },
    map: {
      top: [
        {
          hiliteId: '2-0',
          label: 'Podcenění hlášení',
          ico: 'case',
          color: '#8396cc',
          pos: {
            x: -589,
            y: 175,
          },
        },
      ],
      bottom: [
        {
          hiliteId: '2-1',
          label: 'Kouř u\u00a0duklice',
          ico: 'helmet',
          color: '#b3403a',
          pos: {
            x: 334,
            y: 325,
          },
        },
        {
          hiliteId: '2-1',
          hidden: true,
          label: '',
          ico: 'helmet',
          color: '#b3403a',
          pos: {
            x: 445,
            y: 400,
          },
        },
      ],
    },
  },
  {
    pos: 0.44,
    posLimits: {
      min: 0.42,
      max: 0.46,
    },
    time: 274,
    timeline: {
      top: [
        {
          ico: 'case',
          video: '31568',
          hilite: '3-0',
        },
      ],
      bottom: [
        {
          ico: 'helmet',
          video: '31566',
          hilite: '3-1',
        },
        {
          ico: 'helmet',
          video: '31567',
          hilite: '3-2',
        },
      ],
    },
    map: {
      top: [
        {
          hidden: true,
          hiliteId: '3-0',
          label: '',
          ico: 'case',
          color: '#8396cc',
          pos: {
            x: -589,
            y: 175,
          },
        },
      ],
      bottom: [
        {
          hiliteId: '3-0',
          label: 'Zjištění situace',
          ico: 'case',
          color: '#677593',
          pos: {
            x: 606,
            y: 300,
          },
        },
        {
          hiliteId: '3-1',
          hidden: true,
          label: '',
          ico: 'helmet',
          color: '#b3403a',
          pos: {
            x: 729,
            y: 168,
          },
        },
        {
          hiliteId: '3-1',
          label: 'Situace v\u00a011.\u00a0sloji',
          ico: 'helmet',
          color: '#b3403a',
          pos: {
            x: 752,
            y: 217,
          },
        },
        {
          hiliteId: '3-2',
          label: 'Situace v\u00a08.\u00a0sloji',
          ico: 'helmet',
          color: '#c84c52',
          pos: {
            x: 484,
            y: 226,
          },
        },
      ],
    },
  },
  {
    pos: 0.48,
    posLimits: {
      min: 0.46,
      max: 0.5,
    },
    time: 290,
    timeline: {
      top: [
        {
          ico: 'case',
          video: '31570',
          hilite: '4-0',
        },
        {
          ico: 'case',
          video: '31571',
          hilite: '4-1',
        },
      ],
      bottom: [
        {
          ico: 'helmet',
          video: '31569',
          hilite: '4-2',
        },
      ],
    },
    map: {
      top: [
        {
          hiliteId: '4-0',
          label: 'Příjezd záchranářů',
          ico: 'case',
          color: '#8396cc',
          pos: {
            x: -310,
            y: 180,
          },
        },
        {
          hidden: true,
          hiliteId: '4-1',
          label: '',
          ico: 'case',
          color: '#8396cc',
          pos: {
            x: -589,
            y: 175,
          },
        },
      ],
      bottom: [
        {
          hiliteId: '4-1',
          label: 'Přítomnost kouřů v\u00a08.\u00a0sloji',
          ico: 'case',
          color: '#677593',
          pos: {
            x: 544,
            y: 317,
          },
        },
        {
          hiliteId: '4-2',
          label: 'Opouštění 8.\u00a0sloje',
          ico: 'helmet',
          color: '#b3403a',
          pos: {
            x: 654,
            y: 179,
          },
        },
      ],
    },
  },
  {
    pos: 0.55,
    posLimits: {
      min: 0.53,
      max: 0.57,
    },
    time: 330,
    timeline: {
      top: [
        {
          ico: 'case',
          video: '31573',
          hilite: '5-0',
        },
      ],
      bottom: [
        {
          ico: 'helmet',
          video: '31572',
          hilite: '5-1',
        },
      ],
    },
    map: {
      top: [
        {
          hidden: true,
          hiliteId: '5-0',
          label: '',
          ico: 'case',
          color: '#8396cc',
          pos: {
            x: -589,
            y: 175,
          },
        },
      ],
      bottom: [
        {
          hiliteId: '5-0',
          label: 'Poslední kontakt',
          ico: 'case',
          color: '#677593',
          pos: {
            x: 776,
            y: 152,
          },
        },
        {
          hiliteId: '5-1',
          label: 'Smrt v\u00a0dole',
          ico: 'helmet',
          color: '#b3403a',
          pos: {
            x: 574,
            y: 280,
          },
        },
      ],
    },
  },
  {
    pos: 0.77,
    posLimits: {
      min: 0.75,
      max: 0.79,
    },
    time: 540,
    timeline: {
      top: [
        {
          ico: 'case',
          video: '31575',
          hilite: '6-0',
        },
      ],
      bottom: [
        {
          ico: 'helmet',
          video: '31574',
          hilite: '6-1',
        },
      ],
    },
    map: {
      top: [
        {
          hiliteId: '6-0',
          label: 'Evakuace',
          ico: 'case',
          color: '#8396cc',
          pos: {
            x: -589,
            y: 175,
          },
        },
      ],
      bottom: [
        {
          hiliteId: '6-1',
          label: 'Hrozící výbuch',
          ico: 'helmet',
          color: '#b3403a',
          pos: {
            x: 508,
            y: 318,
          },
        },
      ],
    },
  },
  {
    pos: 0.9,
    posLimits: {
      min: 0.88,
      max: 0.92,
    },
    time: 635,
    timeline: {
      top: [
        {
          ico: 'case',
          video: '31576',
          hilite: '7-0',
        },
      ],
      bottom: [],
    },
    map: {
      top: [
        {
          hiliteId: '7-0',
          label: 'Konec nadějí',
          ico: 'case',
          color: '#8396cc',
          pos: {
            x: -589,
            y: 175,
          },
        },
      ],
      bottom: [],
    },
  },
  {
    pos: 0.95,
    posLimits: {
      min: 0.92,
      max: 1,
    },
    section: 'OUTRO',
  },
];

// ----------------------------------------------------
// Scenes
// ----------------------------------------------------

export const SCENE_TOP = {
  LIMIT_1: {
    MIN: 0.1,
    MAX: 0.5,
  },
  LIMIT_2: {
    MIN: 0.55,
    MAX: 0.63,
  },
  LIMIT_3: {
    MIN: 0.63,
    MAX: 0.8,
  },
};

export const SMOKE_DAY = {
  MAX_Y: -250,
  BASE_ALPHA: 0.7,
  MIN: 0.5,
  MAX: 0.65,
};

export const SCENE_BOTTOM = {
  FIRE: [0.35, 0.4, 0.455, 0.516, 0.75, 0.95],
};

// ----------------------------------------------------
// Sub-Sections
// ----------------------------------------------------

export const SUB_SECTION_VIDEO = {
  INTRO: '31558',
  OUTRO: '31559',
};

// ----------------------------------------------------
// Links
// ----------------------------------------------------

export const LINKS = {
  MOVIE: '//www.ceskatelevize.cz/porady/11490475387-dukla-61/',
  DOCUMENT: '//www.ceskatelevize.cz/porady/12107497654-cerne-zlato/',
};



// WEBPACK FOOTER //
// ./src/content.js